import {defineField, defineType} from 'sanity'
import {BiFileBlank} from 'react-icons/bi'

export default defineType({
  name: 'blog.video',
  title: 'Video',
  type: 'document',
  icon: BiFileBlank,
  groups: [{name: 'content', default: true}, {name: 'cruises'}, {name: 'metadata'}],
  fields: [
    defineField({
      name: 'title',
      type: 'string',
      group: 'content',
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      name: 'video',
      title: 'Video Embed',
      type: 'oembed',
      group: 'content',
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      name: 'featuredMedia',
      title: 'Thumbnail',
      type: 'image',
      group: 'content',
      options: {hotspot: true, metadata: ['lqip']},
    }),
    defineField({
      name: 'content',
      type: 'portableTextVideoContent',
      group: 'content',
    }),
    defineField({
      name: 'publishDate',
      type: 'date',
      group: 'content',
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      name: 'mainCategory',
      type: 'reference',
      to: [{type: 'blog.category'}],
      validation: (Rule) => Rule.required(),
      group: 'content',
    }),
    defineField({
      name: 'tags',
      type: 'array',
      of: [{type: 'reference', to: [{type: 'blog.tag'}]}],
      validation: (Rule) => Rule.required().min(1).max(10).unique(),
      group: 'content',
    }),
    defineField({
      name: 'selectedArticles',
      title: 'Selected Articles',
      type: 'array',
      of: [{type: 'reference', to: [{type: 'blog.post'}], weak: true}],
      group: 'content',
    }),
    defineField({
      name: 'cruiseFilters',
      type: 'cruise-filters',
      group: 'cruises',
    }),
    defineField({
      name: 'metadata',
      type: 'metadata',
      group: 'metadata',
    }),
  ],
  preview: {
    select: {
      title: 'title',
      subtitle: 'mainCategory.title',
      media: 'featuredMedia',
      description: 'publishDate',
    },
  },
})
